import React from "react";
import { appstr } from "@coreapp/utils/appstr";
import UpgradeInfoContainer from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoContainer";
import { enumFeaturesList } from "@coreapp/constants";
import { UpgradeInfoCard } from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoCard";

const UpgradePlanning = () => {
  const positionDataDynamicText = {
    template: appstr("plan position data template"),
    formatConfig: {
      bold1: { type: "bold" },
      bold2: { type: "bold" }
    },
    replaceDict: {
      bold1: appstr("positions and vacancies"),
      bold2: appstr("insight")
    }
  };

  const trackKPIsDynamicText = {
    template: appstr("track kpis template"),
    formatConfig: {
      bold1: { type: "bold" },
      bold2: { type: "bold" }
    },
    replaceDict: {
      bold1: appstr("impact"),
      bold2: appstr("setting and tracking")
    }
  };

  const collaborateDynamicText = {
    template: appstr("collaborate template"),
    formatConfig: {
      bold1: { type: "bold" },
      bold2: { type: "bold" },
      bold3: { type: "bold" }
    },
    replaceDict: {
      bold1: appstr("drag and drop"),
      bold2: appstr("move groups"),
      bold3: appstr("team is aware")
    }
  };

  return (
    <UpgradeInfoContainer featureKey={enumFeaturesList.planning}>
      <UpgradeInfoCard name="calendar-lines-pen-regular">
        <UpgradeInfoCard.Header>{appstr("Plan with Position Data")}</UpgradeInfoCard.Header>
        <UpgradeInfoCard.Body dynamic={positionDataDynamicText}>
          {appstr("plan position data message")}
        </UpgradeInfoCard.Body>
      </UpgradeInfoCard>
      <UpgradeInfoCard name="chart-user-regular">
        <UpgradeInfoCard.Header>{appstr("Track KPIs")}</UpgradeInfoCard.Header>
        <UpgradeInfoCard.Body dynamic={trackKPIsDynamicText}>
          {appstr("track kpis message")}
        </UpgradeInfoCard.Body>
      </UpgradeInfoCard>
      <UpgradeInfoCard name="screen-users-regular">
        <UpgradeInfoCard.Header>{appstr("Collaborate in Real Time")}</UpgradeInfoCard.Header>
        <UpgradeInfoCard.Body dynamic={collaborateDynamicText}>
          {appstr("collaborate message")}
        </UpgradeInfoCard.Body>
      </UpgradeInfoCard>
    </UpgradeInfoContainer>
  );
};

export default UpgradePlanning;
